<template>
    <div class="wb-el-info-anchor"
         :style="{'left': left + 'px', 'top': top + 'px'}" v-on:click.stop>
        <div class="wb-el-color">
            <div class="wb-el-color-tooltip">
                <SVGWarning/>
                <div class="wb-el-color-tooltip-text">
                    {{text}}
                </div>
            </div>
            <div class="wb-el-color-options">
                <div class="wb-overlay-color-picker-option"
                     v-for="option in options"
                     v-on:click="method(option.img)"
                     :key="option.id">
                    <div class="wb-overlay-color-picker-option-img"
                         :style="{'background': option.img}"
                         :class="{'wb-color-bordered': option.isOutline}"
                         :title="option.name">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { itemColorOptions } from '@/Constants/demoData';
import SVGWarning from '@/UI/Components/SVG/SVGWarning.vue';

export default {
    name: 'OverlayElementColor',
    components: {
        SVGWarning,
    },
    props: [
        'top',
        'left',
        'method',
    ],
    data() {
        return {
            text: 'Выбранный цвет будет применен ко всей конструкции',
            options: itemColorOptions,
        };
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/fonts.scss";

.wb-el-info-anchor {
  position: absolute;
  z-index: 100;
}

.wb-el-color {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-sizing: border-box;
    width: 330px;
    background-color: $white;
    flex-grow: 0;
    flex-shrink: 0;
}

.wb-el-color-options {
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 8px;
    justify-content: center;
}

.wb-overlay-color-picker-option {
    width: 88px;
    height: 88px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid $gray1;
    @include wb-c-flex-center;
    cursor: pointer;
    user-select: none;
}

.wb-overlay-color-picker-option:hover {
    border-color: $green1;
}

.wb-overlay-color-picker-option-img {
    width: 72px;
    height: 72px;
    border-radius: 36px;
    background-color: $gray1;
}

.wb-el-color-tooltip {
    display: grid;
    grid-template-columns: max-content auto;
    grid-column-gap: 16px;
    color: $green1
}

.wb-el-color-tooltip-text {
    color: $darkBlue;
    @include font-t1;
    @include wb-c-flex-center-start;
    text-align: left;
}

.wb-color-bordered {
    border: 1px solid #9c9c9c;
}
</style>
